import PropTypes from 'prop-types';
import { Trans, withTranslation } from 'react-i18next';

import { Button, PageError, ThemeImage } from '@ctct/ui-react';

import { useUpgradeContext } from '../UpgradeContext';
import { billingURL } from '../utils/featureUpgradeDialogURLs';

const UpgradeSuccessStep = ({ t, footerContent, footerActions, closeDialog }) => {
  const [upgradeContext] = useUpgradeContext();
  const { planNameDescriptionOnly } = upgradeContext;

  const planName = planNameDescriptionOnly;

  if (!footerContent && !footerActions)
    return (
      <PageError
        data-qe-id="feature-upgrade-success"
        image={<ThemeImage color="green" image="checkmark" size="large" data-qe-id="feature-upgrade-success-image" />}
        heading={t('upgrade-popup.success.heading')}
        description={
          <Trans i18nKey="upgrade-popup.success.body" values={{ planName }}>
            <a href={billingURL} target="_blank" rel="noreferrer">
              {t('upgrade-popup.success.alt')}
            </a>
          </Trans>
        }
      />
    );

  // footerContent
  if (!footerActions) {
    return null;
  }

  // footerActions
  return (
    <Button
      shape="pill"
      data-qe-id="upgrade-success-close-button"
      text={t('upgrade-popup.button-text.close')}
      kind="primary"
      onClick={closeDialog}
    />
  );
};

UpgradeSuccessStep.defaultProps = {
  footerContent: false,
  footerActions: false,
};

UpgradeSuccessStep.propTypes = {
  t: PropTypes.func.isRequired,
  footerContent: PropTypes.bool,
  footerActions: PropTypes.bool,
  closeDialog: PropTypes.func.isRequired,
};

export default withTranslation()(UpgradeSuccessStep);
